import { Field, InputType, Int } from '@nestjs/graphql'
import { IsIn, IsOptional } from '@nestjs/class-validator'
import { bsConstants } from '../../../module.constants'

const SUPPORTED_LOCALES = bsConstants.I18N.LOCALES.map(locale => locale.CODE)

@InputType()
export class UpdateUserPreferencesDto  {
  // Patch-style input: omitted keys should stay omitted.
  // Author
  @Field({ nullable: true })
  public reminderBookLinks?: boolean

  @Field({ nullable: true })
  public dailyUpdatesOnFollowCount?: boolean

  @Field({ nullable: true })
  public alertTimeToPublish?: boolean

  @Field({ nullable: true })
  public alertNewArcParticipant?: boolean

  @Field({ nullable: true })
  public alertNewReview?: boolean

  @Field({ nullable: true })
  public alertArcCancellation?: boolean

  @Field({ nullable: true })
  public alertReviewRejected?: boolean

  @Field({ nullable: true })
  public alertNewExternalReview?: boolean

  // Reviewer
  @Field({ nullable: true })
  public alertNewArc?: boolean

  @Field({ nullable: true })
  public alertNewArcOtherLanguages?: boolean

  @Field({ nullable: true })
  public alertNewArcDigest?: boolean

  @Field(t => String, { nullable: true })
  public newArcDigestFrequency?: string

  @Field(t => String, { nullable: true })
  public arcDigestBannerDismissedAt?: string

  @Field({ nullable: true })
  public alertReviewDueIn2Days?: boolean

  @Field(t => Int, { nullable: true })
  public reviewSitesFlag?: number

  @Field(t => Int, { nullable: true })
  public reviewLanguagesFlag?: number

  @Field({ nullable: true })
  public alertReadyToReview?: boolean

  @Field({ nullable: true })
  public alertFinalFollowup?: boolean

  @Field({ nullable: true })
  public alertDelayExpiring?: boolean

  @Field({ nullable: true })
  public alertDelayExpired?: boolean

  @Field({ nullable: true })
  public alertBookFileUpdated?: boolean

  @Field({ nullable: true })
  public alertSavedArcEndingOrLowCopies?: boolean

  @Field({ nullable: true })
  public emailOnMessage?: boolean

  @Field({ nullable: true })
  public alertNewTeamApplicant?: boolean

  @Field({ nullable: true })
  public invitedToTeam?: boolean

  @Field({ nullable: true })
  public freeText?: boolean

  @Field(t => String, { nullable: true })
  public findArcFilters?: string

  // Global
  @Field(t => String, { nullable: true })
  public brevoLists?: string

  // @IsOptional is load-bearing: the global ValidationPipe would otherwise reject every update
  // that leaves the language alone, which is nearly all of them.
  @Field(t => String, { nullable: true })
  @IsOptional()
  @IsIn(SUPPORTED_LOCALES)
  public uiLocale?: string
}
